// extracted by mini-css-extract-plugin
module.exports = {"InputUpload":"fileUpload_InputUpload__bS9S6"};